import React, { useState, Fragment, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { Card, CardBody, Col, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import columns from './components/Columns';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import MatTable from '../../shared/components/material-table';
import GraphQL from '../../GraphQL';
import Modal from '../../shared/components/Modal';
import {
  evaluationCriteriaListAll,
  evaluationCriteriaRemove,
} from '../../shared/queries/EvaluationCriteria';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';

const EvaluationCriteria = (props) => {
  const { t, dispatch, history } = props;

  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const loadData = () => {
    showLoading();
    const dataQuery = evaluationCriteriaListAll();
    GraphQL(dataQuery, {})
      .then((res) => {
        hideLoading();
        let evaluationCriteriaList = res.evaluationCriteriaListAll;
        evaluationCriteriaList = evaluationCriteriaList.map((item) => ({
          ...item,
          activeDescription: t(`general.yesno.${item.active}`),
        }));
        setData(evaluationCriteriaList);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const addItemClickHandler = () => {
    setSelectedDto({ active: true, id: 0 });
    history.push('/minime/criterio-avaliacao/mnt/0');
  };

  const editItemClickHandler = (evt, rowData) => {
    const clickedItem = {
      ...rowData,
    };
    setSelectedDto(clickedItem);
    history.push(`/minime/criterio-avaliacao/mnt/${rowData.id}`);
  };

  const removeItemClickHandler = (evt, rowData) => {
    const clickedItem = {
      ...rowData,
    };
    setSelectedDto(clickedItem);
    toggleModal();
  };

  const deleteItem = () => {
    toggleModal();
    showLoading();
    const removeQuery = evaluationCriteriaRemove(selectedDto);
    GraphQL(removeQuery, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
        loadData();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-remove')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    onRefreshClick={loadData}
                    onAddClick={addItemClickHandler}
                    onEditClick={editItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    data={data}
                    columns={columns(t)}
                    pageSize={20}
                    deleteAction={toggleModal}
                    title={t('panels.criterio-avaliacao')}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

EvaluationCriteria.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(EvaluationCriteria)
);
